import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  AddPackageLayer  from '../components/package/AddPackageLayer'

export const AddPackagePage = () => {
  return (
    <MasterLayout>
        <AddPackageLayer/>
    </MasterLayout>
  )
}
